import { FieldModel, ProgramEngagementStatus, TaskStatusReason } from '@cibo/core'
import { useReasonMessages } from '@cibo/ui'
import { Stack } from '@mui/system'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { resourceDetailFeatureByTraitId } from '../../features/Tasks/BenchmarkStatus/resourceDetailFeatureMap'

const FieldTaskWarningCell = ({
  allWarnings,
  resourceId,
}: {
  allWarnings: TaskStatusReason[]
  resourceId: string
}) => {
  const { byReasonCode } = useReasonMessages()
  return (
    <Stack>
      {allWarnings?.map(({ reasons, id }) =>
        reasons.map(({ reason, traitId }) => {
          const Trait = resourceDetailFeatureByTraitId(traitId)
          if (Trait?.Component?.SingleDetailEditor) {
            return <Trait.Component.SingleDetailEditor resourceId={resourceId} />
          } else {
            return <span key={traitId}>{byReasonCode({ reasonCode: reason, traitId })}</span>
          }
        })
      )}
    </Stack>
  )
}

export const fieldTaskWarningColumn = ({
  t,
  warnings,
}: {
  t: TFunction
  warnings: ProgramEngagementStatus['status']['warnings']
}) => ({
  field: 'taskWarnings',
  filterable: false,
  sortable: false,
  hideable: false,
  rowHeight: () => 'auto',
  headerName: t('headerName', { ns: '@cibo/programs/fieldTaskWarningColumn' }),
  renderCell: (params: GridRenderCellParams<any, FieldModel & { locked: boolean }>) => {
    const allWarnings = warnings?.reasonItems?.filter(
      ({ dataType, id }) => id === params.row.id && dataType === 'field'
    )
    return allWarnings?.length ? (
      <FieldTaskWarningCell allWarnings={allWarnings} resourceId={params.row.resourceId} />
    ) : null
  },
})
